import appraisalSalesTypes from '@/domain/constants/appraisal-sales-types';

const EMPTY = '';
const DATE_SEPARATOR = '-';
const DEFAULT_SALES_TYPE = appraisalSalesTypes[0];

class AppraisalFilename {
  setType(value) {
    this.type = value;
    return this;
  }

  setInvestor(value) {
    this.investor = value;
    return this;
  }

  setDate(value) {
    this.date = value;
    return this;
  }
}

function formatToISODate(date) {
  const splitDate = date.split(DATE_SEPARATOR);
  const dateInISOFormat = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
  const isValidDate = Number.isNaN(Date.parse(dateInISOFormat));
  if (isValidDate) {
    return EMPTY;
  }
  return dateInISOFormat;
}

function parseDate(filename) {
  const re = /.*(\d{2}-\d{2}-\d{4})/gm;
  const found = [...filename.matchAll(re)];
  const notFoundDate = found[0] === undefined || found[0][1] === undefined;
  if (notFoundDate) {
    return EMPTY;
  }
  return formatToISODate(found[0][1]);
}

function parseType(filename) {
  const upperFilename = filename.toUpperCase();
  const salesTypeObj = appraisalSalesTypes.find(type => upperFilename.includes(type.name)) || DEFAULT_SALES_TYPE;
  // return salesTypeObj.name || EMPTY; // Todos los appraisalSalesTypes así cómo el DEFAULT_SALES_TYPE tienen name, jamás se cumple la condición.
  return salesTypeObj.name;
}

function parseInvestor(filename, investorList) {
  const upperFilename = filename.toUpperCase();
  const investorObj = investorList.find(investor => upperFilename.includes(investor.name.toUpperCase())) || EMPTY;
  return investorObj.name || EMPTY;
}

export const appraisalInformationFromFilename = (fileName, investorList) => {
  const info = new AppraisalFilename();
  info.setDate(parseDate(fileName));
  info.setType(parseType(fileName));
  info.setInvestor(parseInvestor(fileName, investorList || []));
  return info;
};
